<template>
  <span class="text-red-500 font-semibold" v-tooltip.top="'Required'">*</span>
</template>
